import generalUpload from "../_section/upload.class";
import {lastYear1, lastYear2, lastYear3} from "../../../../../../assets/scripts/verifiable-section/verifiableSection";
import dayjs from "dayjs";
export class userSalaryCertUpload extends generalUpload {
    constructor(request, upload, queries) {
        super(request, upload, queries);
    }
}
const template= {
    items: [
        {
            name: 'documentDate',
            label: 'Document Date',
            type: 'date',
        },
        {
            name: 'employmentStartDate',
            label: 'Employment Start Date',
            type: 'date',
        },
        {
            name: 'grossBasicThisYear',
            label: 'Gross Basic This Year',
            type: 'currency',
        },
        {
            name: 'grossBasicYearMostRecent',
            label: 'Gross Basic Year Most Recent',
            type: 'currency',
            optional: true
        },
         {
            name: 'grossBasicYearBefore',
            label: 'Gross Basic Year Before',
            type: 'currency',
            optional: true
        }, {
            name: 'grossBasicYearBeforeThat',
            label: 'Gross Basic Year Before That',
            type: 'currency',
            optional: true
        },
        // CAR ALLOWANCE
        {
            name: 'carAllowanceYearMostRecent',
            label: 'carAllowanceYearMostRecent',
            type: 'currency',
            optional: true
        }, {
            name: 'carAllowanceYearBefore',
            label: 'carAllowanceYearBefore',
            type: 'currency',
            optional: true
        }, {
            name: 'carAllowanceYearBeforeThat',
            label: 'carAllowanceYearBeforeThat',
            type: 'currency',
            optional: true
        }, {
            name: 'carAllowanceGuaranteed',
            label: 'carAllowanceGuaranteed',
            type: 'check',
            optional: true
        },
        //SHIFT ALLOWANCE
        {
            name: 'shiftAllowanceYearMostRecent',
            label: 'Shift Allowance Year Most Recent',
            type: 'currency',
            optional: true
        }, {
            name: 'shiftAllowanceYearBefore',
            label: 'Shift Allowance Year Before',
            type: 'currency',
            optional: true
        }, {
            name: 'shiftAllowanceYearBeforeThat',
            label: 'Shift Allowance Year Before That',
            type: 'currency',
            optional: true
        }, {
            name: 'shiftAllowanceGuaranteed',
            label: 'shiftAllowanceGuaranteed',
            type: 'check',
            optional: true
        },
        //OTHER ALLOWANCE
        {
            name: 'otherAllowanceYearMostRecent',
            label: 'Other Allowance Year Most Recent',
            type: 'currency',
            optional: true
        }, {
            name: 'otherAllowanceYearBefore',
            label: 'Other Allowance Year Before',
            type: 'currency',
            optional: true
        }, {
            name: 'otherAllowanceYearBeforeThat',
            label: 'otherAllowanceYearBeforeThat',
            type: 'currency',
            optional: true
        }, {
            name: 'otherAllowanceGuaranteed',
            label: 'otherAllowanceGuaranteed',
            type: 'check',
            optional: true
        },
        //OVERTIME
        {
            name: 'overtimeYearMostRecent',
            label: 'overtime Year Most Recent',
            type: 'currency',
            optional: true
        }, {
            name: 'overtimeYearBefore',
            label: 'overtime Year Before',
            type: 'currency',
            optional: true
        }, {
            name: 'overtimeYearBeforeThat',
            label: 'overtimeYearBeforeThat',
            type: 'currency',
            optional: true
        }, {
            name: 'overtimeGuaranteed',
            label: 'overtimeGuaranteed',
            type: 'check',
            optional: true
        }, //bonus
        {
            name: 'bonusYearMostRecent',
            label: 'bonus Year Most Recent',
            type: 'currency',
            optional: true
        }, {
            name: 'bonusYearBefore',
            label: 'bonus Year Before',
            type: 'currency',
            optional: true
        }, {
            name: 'bonusYearBeforeThat',
            label: 'bonusYearBeforeThat',
            type: 'currency',
            optional: true
        }, {
            name: 'bonusGuaranteed',
            label: 'bonusGuaranteed',
            type: 'check',
            optional: true
        }, // commission
        {
            name: 'commissionYearMostRecent',
            label: 'commission Year Most Recent',
            type: 'currency',
            optional: true
        }, {
            name: 'commissionYearBefore',
            label: 'commission Year Before',
            type: 'currency',
            optional: true
        }, {
            name: 'commissionYearBeforeThat',
            label: 'commissionYearBeforeThat',
            type: 'currency',
            optional: true
        }, {
            name: 'commissionGuaranteed',
            label: 'commissionGuaranteed',
            type: 'check',
            optional: true
        },
        {
            optional: true,
            name: 'grossBasic',
            label: 'Gross Basic',
            type: 'currency',
        },
        {
            name: 'overtime',
            label: 'Overtime',
            type: 'currency',
            optional: true
        }, {
            name: 'commission',
            label: 'Commission',
            type: 'currency',
            optional: true
        }, {
            name: 'allowances',
            label: 'Allowances',
            type: 'currency',
            optional: true
        }, {
            name: 'allowancesGuaranteed',
            label: 'Guaranteed',
            type: 'check',
            optional: true
        }, //shift allowance
        //TODO : add in next 3 payscales
        {
            name: 'other',
            label: 'Other',
            type: 'currency',
            optional: true
        }, {
            name: 'otherGuaranteed',
            label: 'Guaranteed',
            type: 'check',
            optional: true
        }, ...(() => {
            return [
                lastYear1, lastYear2, lastYear3
            ].flatMap(year => {
                if (year === lastYear1) {
                    return [
                        {
                            name: `${year}bonus`,
                            label: `Bonus ${year}`,
                            type: 'currency',
                            optional: true
                        }, {
                            name: `${year}bonusGuaranteed`,
                            label: `Guaranteed`,
                            type: 'check',
                            optional: true
                        }
                    ]
                }
                return [
                    {
                        name: `${year}bonus`,
                        label: `Bonus ${year}`,
                        type: 'currency',
                        optional: true
                    }
                ]
            })
        })()
    ]
}
export class adminSalaryCertUpload extends userSalaryCertUpload {

    constructor(request, upload, queries) {
        super(request, upload, queries);
        this.calcValues(template)
        if (this.values.documentDate) {
            if (!dayjs.isDayjs(this.values.documentDate)) {
                this.values.documentDate = dayjs(this.values.documentDate);
            }
            let expiryDate = this.values.documentDate.add(3, 'month');
            // if (request.mortgage && request.mortgage.activeSubmission && request.mortgage.activeSubmission.lenderCode === "boi") {
            //     expiryDate = this.values.documentDate.add(3, 'month');
            // }
            this.setDateData({
                dated: this.values.documentDate,
                expires: expiryDate,
            })
        }
    }
}
